import script from "./RetailScheduledTask.vue?vue&type=script&setup=true&lang=ts"
export * from "./RetailScheduledTask.vue?vue&type=script&setup=true&lang=ts"

import "./RetailScheduledTask.vue?vue&type=style&index=0&id=279a5312&scope=true&lang=css"

const __exports__ = script;

export default __exports__